import { lazy } from 'react';

export const TwoFactorSetupPage = lazy(() => import('./TwoFactorSetupPage'));
